import { Talent } from "../../../../interfaces/resources/talent";
import client from "../../client";

export function getQuizAnswers(talent: Talent) {
  return client.get(
    `${talent["@id"]}/talent_profile/quiz_answers?order[createdAt]=ASC&question.type[]=ordered&question.type[]=unique`,
  );
}
